import React from 'react'
import { usePaginationFragment, useFragment, graphql } from 'react-relay'

import { useMedia } from 'tamagui'
import { EventList } from '@newComponents'

import { GuildEventsPastCard_guild$key } from './__generated__/GuildEventsPastCard_guild.graphql'
import { GuildEventsPastCard_query$key } from './__generated__/GuildEventsPastCard_query.graphql'

export const GuildEventsPastCard = ({
  guild,
  query,
}: {
  guild: GuildEventsPastCard_guild$key
  query: GuildEventsPastCard_query$key
}) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment GuildEventsPastCard_guild on Guild
      @refetchable(queryName: "GuildEventsPastCardPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        pastEvents: eventsByTimeSelection(
          first: $count
          after: $cursor
          timeSelection: PAST
          orderBy: [START_AT_DESC, ID_ASC]
        ) @connection(key: "GuildEventsPastCard_guild_pastEvents") {
          edges {
            node {
              id
              ...EventItemNew_event
            }

            cursor
          }

          ...EventList_eventsConnection
        }
      }
    `,
    guild
  )

  const queryData = useFragment(
    graphql`
      fragment GuildEventsPastCard_query on Query {
        ...EventList_query
      }
    `,
    query
  )

  const media = useMedia()

  return (
    <EventList
      eventsConnection={data.pastEvents}
      query={queryData}
      hasNext={hasNext}
      loadNext={loadNext}
      forceVertical={media.md}
    />
  )

  // return (
  //   <YStack gap='$4'>
  //     <H2>Past Events</H2>

  //     <EventList
  //       eventsConnection={data.pastEvents}
  //       query={queryData}
  //       hasNext={hasNext}
  //       loadNext={loadNext}
  //     />

  //     {/* {data.pastEvents.edges.map((edge) => {
  //       return (
  //         <EventItem key={edge.cursor} event={edge.node} query={queryData} />
  //       )
  //     })}

  //     {hasNext && (
  //       <Button
  //         variant='secondary'
  //         hoverVariant='secondaryHover'
  //         onPress={() => {
  //           if (isLoadingNext) {
  //             return
  //           }

  //           loadNext(3)
  //         }}
  //       >
  //         <Text variant='buttonSecondary' size={4}>
  //           {isLoadingNext ? 'Loading...' : 'More'}
  //         </Text>
  //       </Button>
  //     )} */}
  //   </YStack>
  // )
}
